import { useReducer } from 'react';
import { RewardsViewReducer } from './rewardsReducer';
import { RewardsViewContext } from './rewardsContext';
import { UPDATE_REWARDS_VIEW } from './types';

export const RewardsViewState = (props) => {

    const initialState = {
        rewardsViewData: {
            openDisclosure: false,
            openDisclosureMyRewards: false,
        }
    }

    const [state, dispatch] = useReducer(RewardsViewReducer, initialState);

    const updateRewardsView = (data) => {
        dispatch({
            type: UPDATE_REWARDS_VIEW,
            payload: data
        });
    }

    return (
        <RewardsViewContext.Provider value={
            {
                rewardsViewData: state.rewardsViewData,
                updateRewardsView
            }}>
            {props.children}
        </RewardsViewContext.Provider>
    )
}


